import {
    connect,
} from 'react-redux';
import View from './BreakdownView';
import {
    setOpen,
} from '../../NotesPopup/NotesPopupActions';
import {
    isCurrentPlanSelector,
} from '../../../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';


const mapStateToProps = (state, ownProps) => {
    return {
        isCurrentPlan: isCurrentPlanSelector(state, ownProps),
        isAdviserArea: ADV.util.env('isAdviserArea'),
        hasPassiveIncome: !!ownProps.breakdown.PassiveIncome,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onNotesClick: (clientId, goalId, subgoalId, noteDescription) => (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(setOpen(clientId, goalId, subgoalId, true, noteDescription));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
